
















import Vue, { PropType } from 'vue';
// import { BrandData } from '@/modules/exhibitor/brand';
import {
  BrandData,
} from 'mostra';

export default Vue.extend({
  name: 'GBrandTop',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    brands: {
      type: Array as PropType<BrandData[]>,
    },
  },
  methods: {
    onClickEdit(id: string) {
      return () => {
        this.$router.push({
          name: 'exhibitor-brand-edit',
          query: { page: 'preview', id: id },
        });
      };
    },
  },
});
